// components/ComingSoonPage.jsx

import { Button } from "./ui/button";

export default function ComingSoonPage({ appName, teaser, imageSrc }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center bg-background">
      <h1 className="text-4xl font-bold mb-2">{appName}</h1>
      <p className="text-muted-foreground mb-6">{teaser}</p>

      <div className="relative w-full max-w-3xl aspect-video overflow-hidden rounded-2xl shadow-lg mb-6">
      <img
          src={imageSrc}
          alt={`${appName} preview`}
          className="w-full h-full object-cover blur-sm opacity-60"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="bg-primary text-white text-xl font-semibold px-6 py-2 rounded-full shadow-md">🚧 Coming Soon</span>
        </div>
      </div>

      <Button variant="outline">Notify Me</Button>
    </div>
  );
}
